module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/200.7c688b56.png";